import * as React from "react";
import { Query, Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import Select from "react-select";

// GraphQL
import CreatePartMutation from "../../GraphQL/Mutations/CreatePart";
import GetCompanySites from "../../GraphQL/Queries/GetCompanySites";
import GetCompanyParts from "../../GraphQL/Queries/GetCompanyParts";

// Presentation/UI
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

interface IProps {
  companyId: any;
  closeModal(): void;
  notification(message: string): void;
}

interface IState {
  name: string;
  description: string;
  category: string;
  quantity: string;
  barcode: string;
  additionalPartDetails: string;
  loading: boolean;
  siteId: any;
  error: null | string;
}

class AddPartForm extends React.Component<IProps, IState> {
  state = {
    name: "",
    description: "",
    category: "",
    quantity: "",
    barcode: "",
    additionalPartDetails: "",
    loading: false,
    siteId: null,
    error: null
  };

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value }: { name: string; value: string } = e.currentTarget;

    switch (name) {
      case "partName":
        this.setState({ name: value });
        break;
      case "description":
        this.setState({ description: value });
        break;
      case "category":
        this.setState({ category: value });
        break;
      case "quantity":
        this.setState({ quantity: value });
        break;
      case "barcode":
        this.setState({ barcode: value });
        break;
      case "additionalPartDetails":
        this.setState({ additionalPartDetails: value });
        break;
      default:
        break;
    }
  };

  // Select site
  selectSite = (site: any) => {
    const siteId = site.value.id;
    this.setState({ siteId });
  };

  // Return sites
  returnSites = (
    sites: Array<any>
  ): Array<{ value: object; label: string }> => {
    return sites.map((site: any) => {
      return {
        value: site,
        label: `${site.name}`
      };
    });
  };

  validateForm = (): boolean => {
    const { name } = this.state;
    // Check for undefined or empty infput fields
    if (!name) {
      this.setError("Please fill in the name of the part");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const {
      name,
      description,
      category,
      quantity,
      barcode,
      additionalPartDetails,
      siteId
    } = this.state;

    const { companyId, closeModal, notification } = this.props;
    return (
      <Query query={GetCompanySites} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the data</div>;
          }

          const sites = data.allSites;

          return (
            <Mutation<{}, {}> mutation={CreatePartMutation}>
              {createPart => (
                <Form
                  onSubmit={e => {
                    e.preventDefault();
                    if (this.validateForm()) {
                      this.setState({ loading: true });

                      createPart({
                        variables: {
                          name,
                          description,
                          category,
                          quantity,
                          barcode,
                          additionalPartDetails,
                          siteId,
                          companyId
                        },
                        refetchQueries: [
                          {
                            query: GetCompanyParts,
                            variables: { id: companyId }
                          }
                        ]
                      })
                        .then(res => {
                          this.setState({ loading: false });

                          closeModal();
                          notification("Part created successfully");
                        })
                        .catch(err => {
                          this.setState({ loading: false });
                        });
                    }
                  }}
                >
                  <FormGroup>
                    <Label for="partName">Part Name</Label>
                    <Input
                      type="text"
                      name="partName"
                      id="partName"
                      placeholder="Part name"
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="description">Description</Label>
                    <Input
                      type="textarea"
                      name="description"
                      id="description"
                      placeholder="Description"
                      onChange={this.handleChange}
                      style={{ resize: "none" }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="category">Category</Label>
                    <Input
                      type="text"
                      name="category"
                      id="category"
                      placeholder="Category"
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="category">Barcode</Label>
                    <Input
                      type="text"
                      name="barcode"
                      id="barcode"
                      placeholder="Barcode"
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>Site</Label>
                    <Select
                      onChange={this.selectSite}
                      options={this.returnSites(sites)}
                      isSearchable={true}
                      placeholder="Sites"
                      className="select-styling"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="additionalPartDetails">
                      Additional Part Details
                    </Label>
                    <Input
                      type="textarea"
                      name="additionalPartDetails"
                      id="additionalPartDetails"
                      placeholder="Additional part details"
                      onChange={this.handleChange}
                      style={{ resize: "none" }}
                    />
                  </FormGroup>
                  <br />
                  <FormGroup>
                    <Button>
                      {!this.state.loading ? <span>Save</span> : <Loader />}
                    </Button>
                  </FormGroup>
                  {this.state.error && (
                    <p style={{ textAlign: "center", color: Colors.error }}>
                      {this.state.error}
                    </p>
                  )}
                </Form>
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

export default AddPartForm;



// WEBPACK FOOTER //
// ./src/Containers/Parts/AddPartForm.tsx